import FilterOperator from "../Filters/FilterOperator";
import FilterPropertyType from "../Filters/FilterPropertyType";
import FilterPropertyRenderType from "../Filters/FilterPropertyRenderType";

const filterProperties = [
	{
		name: "Type",
		key: "classification",
		type: FilterPropertyType.ENUM,
		typeData: {
			options: []
		},
		operators: [FilterOperator.IS, FilterOperator.IS_NOT]
	},
	{
		name: "Name",
		key: "name",
		type: FilterPropertyType.STRING,
		typeData: {
			caseSensitive: false
		},
		operators: [FilterOperator.IS, FilterOperator.IS_NOT, FilterOperator.LIKE, FilterOperator.NOT_LIKE]
	},
	{
		name: "Flag",
		key: "flag",
		type: FilterPropertyType.ENUM,
		typeData: {
			renderType: FilterPropertyRenderType.FLAG,
			options: []
		},
		operators: [FilterOperator.IS, FilterOperator.IS_NOT]
	},
	{
		name: "Destination",
		key: "voyageDestination",
		type: FilterPropertyType.STRING,
		typeData: {
			caseSensitive: false
		},
		operators: [FilterOperator.IS, FilterOperator.IS_NOT, FilterOperator.LIKE, FilterOperator.NOT_LIKE]
	},
	{
		name: "ETA",
		key: "voyageEta",
		type: FilterPropertyType.RELATIVE_TIME,
		operators: [FilterOperator.GT, FilterOperator.LT],
		operatorAliases: {
			[FilterOperator.GT]: "LATER THAN",
			[FilterOperator.LT]: "EARLIER THAN"
		}
	},
	{
		name: "Speed",
		key: "speed",
		type: FilterPropertyType.NUMBER,
		operators: [FilterOperator.GT, FilterOperator.LT]
	},
	{
		name: "IMO",
		key: "imo",
		type: FilterPropertyType.STRING,
		typeData: {
			caseSensitive: false
		},
		operators: [FilterOperator.IS, FilterOperator.IS_NOT, FilterOperator.LIKE, FilterOperator.NOT_LIKE]
	}
];
export default filterProperties;
